<template>
    <v-container fluid fill-height>
        <v-layout style="display: block;">
            <profile-index/>
        </v-layout>
    </v-container>
</template>
<script>
    import ProfileIndex from "../../components/dashboard/settings/ProfileIndex";
    
    export default  {
        components: {
            ProfileIndex,
        }
    }
</script>